export default {
  F: "#00639a",
  W: "#00639a",
  Y: "#00639a",
  H: "#00639a",
};
